export default "__VITE_ASSET__zYKjrhn3__"